<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 style="text-align: center">Configurações</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <label for="client_id">Application ID</label>
            <input
              id="client_id"
              type="client_id"
              class="form-control"
              v-model="state.client_id"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="client_secret">Client Secret</label>
            <input
              id="client_secret"
              type="client_secret"
              class="form-control"
              v-model="state.client_secret"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="url">Redirect URI</label>
            <input
              id="url"
              type="url"
              class="form-control"
              v-model="state.url"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="url">Code</label>
            <input
              id="code"
              type="code"
              class="form-control"
              v-model="state.code"
            />
          </div>
        </div>
        <div class="btns_right mt-3">
          <button @click="upEmpresa" type="button" class="btn_save">
            Salvar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      client_id: "",
      url: "",
      client_secret: "",
    });
    onMounted(() => {
      fetchConfiguracao();
    });

    async function fetchConfiguracao() {
      try {
        const { data } = await services.configuracao.get({
          token,
        });
        state.url = data.url;
        state.client_id = data.client_id;
        state.client_secret = data.client_secret;
        state.code = data.code;
      } catch (error) {
        console.log(error);
      }
    }
    async function upEmpresa() {
      try {
        await services.configuracao.update({
          url: state.url,
          client_id: state.client_id,
          client_secret: state.client_secret,
          code: state.code,
          token,
        });
        alert("Configurações atualizadas com sucesso!");
      } catch {
        alert("Erro ao atualizar!");
      }
    }
    return {
      upEmpresa,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #8b0000;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #8b0000;
}
.btns_right {
  text-align: right;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
</style>